import { requireSeeker } from '@/router/guards/authGuards';

const photoUploadRoutes = [
  {
    path: '/account/seeker/photo',
    name: 'seeker-photo-upload',
    component: () => import('@/apps/account/seeker/photo/AccountSeekerPhoto.vue'),
    beforeEnter: requireSeeker,
  },
];

export default photoUploadRoutes;
